<template>
  <div>
    <Divider orientation="left">个人信息变更确认</Divider>
    <Form :ref="'form' + current" :model="form" :rules="rules" :label-width="165">
      <Row :gutter="16">
        <Col span="24">
        <FormItem label="姓名变更" prop="isNameChanged">
          <Checkbox v-model.trim="form.isNameChanged"></Checkbox>
        </FormItem>
        </Col>
        <Col span="12">
        <FormItem label="变更前姓名" :required="form.isNameChanged" prop="oldName" :rules="[{required: form.isNameChanged,message: '请输入',trigger: 'blur',},{ required:form.isNameChanged,message: '请输入',trigger: 'change',}]">
          <Input v-model.trim="form.oldName" :maxlength="40" placeholder="请输入"></Input>
        </FormItem>
        </Col>
        <Col span="12">
        <FormItem label="变更后姓名" :required="form.isNameChanged" prop="newName" :rules="[{ required:form.isNameChanged,message: '请输入',trigger: 'blur',},{ required:form.isNameChanged,message: '请输入',trigger: 'change',}]">
          <Input v-model.trim="form.newName" :maxlength="40" placeholder="请输入"></Input>
        </FormItem>
        </Col>
        <Col span="24">
        <FormItem class="noticeTop" label="证明材料" :required="form.isNameChanged" prop="nameChangedFileGuidList" :rules="{ required: form.isNameChanged,type:'array',message: '请上传',trigger: 'change',}">
          <Upload style="flex: 1" :show-upload-list="false" :accept="$store.state.globalAccept" :format="$store.state.globalFormat" :default-file-list="form.nameChangedFileGuidListPreview" :action="$baseURL + '/common/file/uploadfile'"
            :on-preview="handlePreview" :data="uploadData" :on-remove="
                (file, fileList) =>
                  handleRemove(file, fileList, 'nameChangedFileGuidList',true)
              " :on-success="
                (response, file, fileList) =>
                  handleSuccess(
                    response,
                    file,
                    fileList,
                    'nameChangedFileGuidList',true
                  )
              " :on-format-error="handleFormatError">
            <Button icon="ios-folder">上传电脑文件</Button>&nbsp;
            <Button icon="ios-camera" @click.stop="openQrCodeUpload('nameChangedFileGuidList',true)">手机拍照上传</Button>

          </Upload>
        </FormItem>
        <FormItem class="notice">
          <div>现用名和曾用名的户口本单页及首页/户籍证明</div>
          <div class="_linkdel" v-for="file in form.nameChangedFileGuidListPreview" :key="file.guid">
            <div class="fileCentent" @click="handlePreview(file)">
              <Icon :type="file.name | fileType" />
              {{file.name?file.name:file.fileName}}
            </div>
            <div class="fileDel">
              <Icon type="md-close" @click="handleRemove(file, null, 'nameChangedFileGuidList',true)" />
            </div>
          </div>
        </FormItem>
        </Col>
        <Col span="24">
        <FormItem prop="isIDCardNoChanged" label="身份证号码变更">
          <Checkbox v-model.trim="form.isIDCardNoChanged"></Checkbox>
        </FormItem>
        </Col>
        <Col span="12">
        <FormItem label="变更前身份证号码" :required="form.isIDCardNoChanged" prop="oldIDCardNo" :rules="{ required: form.isIDCardNoChanged,message: '请输入',trigger: 'change',}">
          <Input v-model.trim="form.oldIDCardNo" :maxlength="40" placeholder="请输入"></Input>
        </FormItem>
        </Col>
        <Col span="12">
        <FormItem label="变更后身份证号码" :required="form.isIDCardNoChanged" prop="newIDCardNo" :rules="{ required: form.isIDCardNoChanged,message: '请输入',trigger: 'change',}">
          <Input v-model.trim="form.newIDCardNo" :maxlength="40" placeholder="请输入"></Input>
        </FormItem>
        </Col>
        <Col span="24">
        <FormItem class="noticeTop" label="证明材料" :required="form.isIDCardNoChanged" prop="idCardNoChangedFileGuidList" :rules="{ required: form.isIDCardNoChanged,type:'array',message: '请上传',trigger: 'change',}">
          <Upload :show-upload-list="false" :accept="$store.state.globalAccept" :format="$store.state.globalFormat" :default-file-list="form.idCardNoChangedFileGuidListPreview" style="flex: 1" :action="$baseURL + '/common/file/uploadfile'"
            :on-preview="handlePreview" :data="uploadData" :on-remove="
                (file, fileList) =>
                  handleRemove(file, fileList, 'idCardNoChangedFileGuidList',true)
              " :on-success="
                (response, file, fileList) =>
                  handleSuccess(
                    response,
                    file,
                    fileList,
                    'idCardNoChangedFileGuidList',
                    true
                  )
              " :on-format-error="handleFormatError">
            <Button icon="ios-folder">上传电脑文件</Button>&nbsp;
            <Button icon="ios-camera" @click.stop="openQrCodeUpload('idCardNoChangedFileGuidList',true)">手机拍照上传</Button>

          </Upload>
        </FormItem>
        <FormItem class="notice">
          <div>公民身份证号码变更证明等公安部门出具的证明</div>
          <div class="_linkdel" v-for="file in form.idCardNoChangedFileGuidListPreview" :key="file.guid">
            <div class="fileCentent" @click="handlePreview(file)">
              <Icon :type="file.name | fileType" />
              {{file.name?file.name:file.fileName}}
            </div>
            <div class="fileDel">
              <Icon type="md-close" @click="handleRemove(file, null, 'idCardNoChangedFileGuidList',true)" />
            </div>
          </div>
        </FormItem>
        </Col>
      </Row>
      <div class="bom_btn">
        <div>
          <Button @click="next(null,  - 1)">上一步</Button>
          <Button type="primary" @click="next('form' + current,1)">下一步</Button>
        </div>
      </div>
    </Form>
    <!-- <Modal title="请人事使用微信扫码核验身份" v-model="QRshow" :closable="false" :mask-closable="false">
      <template #header>
        <p>
          <img src="../../../../assets/images/weixin.png" class="QRtitle">
          <span>请人事使用微信扫码核验身份</span>
        </p>
      </template>
      <div class="QRcode">
        <img :src="'data:image/png;base64,'+QRcode" alt="">
      </div>
      <Spin size="large" fix v-if="loading"></Spin>
      <template #footer>
        <Button @click="colseQR()" style="margin-right: 5px">关闭</Button>
      </template>
    </Modal> -->
  </div>
</template>
<script>
export default {
  props: { form: { type: Object }, current: { type: Number } },
  data() {
    return {
      format: ['jpg', 'png', 'jpeg'],
      accept: 'image/*',
      //   form: { id: 'ywlsh_12356789', kh: '新开户', sfzzm: [] },
      uploadData: {},
      QRshow: false,
      loading: false,
      timer: null,
      appInfoDataType: this.$store.state.appInfoDataType,
      current_index: this.current,
      rules: {
        // oldName: [
        //   {
        //     required: this.form.isNameChanged,
        //     message: "请输入",
        //     trigger: "change",
        //   },
        // ],
        // newName: [
        //   {
        //     required: this.form.isNameChanged,
        //     message: "请输入",
        //     trigger: "change",
        //   },
        // ],
        // nameChangedFileGuidList: [
        //   {
        //     required: this.form.isNameChanged,
        //     message: "请上传",
        //     trigger: "change",
        //   },
        // ],
        // oldIDCardNo: [
        //   {
        //     required: this.form.isIDCardNoChanged,
        //     message: "请输入",
        //     trigger: "change",
        //   },
        // ],
        // newIDCardNo: [
        //   {
        //     required: this.form.isIDCardNoChanged,
        //     message: "请输入",
        //     trigger: "change",
        //   },
        // ],
        // idCardNoChangedFileGuidList: [
        //   {
        //     required: this.form.isIDCardNoChanged,
        //     message: "请上传",
        //     trigger: "change",
        //   },
        // ],
      },
      clList: ['rl', 'dw', 'yy', 'sh', 'rl'],
      selectList: [
        { name: '是', value: 1 },
        { name: '否', value: 0 },
      ],
    }
  },
  methods: {
    //下一步
    next(name, val) {
      let _this = this
      //上一步
      if (name === null) {
        this.$emit('next', val, '/api/services/app/JZZJFApi/SaveAppPersonalInfoChangeInfo')
        return
      } else {
        this.submit(name, val)
      }
    },
    //提交
    submit(name, val) {
      let _this = this

      if (!this.form.isNameChanged && !this.form.isIDCardNoChanged) {
        this.$Message.error('至少需要变更一项')
        return
      }
      this.$refs[name].validate(async (valid) => {
        if (!valid) {
          this.$Message.error('请将信息填写完整')
          return
        }
        _this.$emit('next', val, '/api/services/app/JZZJFApi/SaveAppPersonalInfoChangeInfo')
        // this.checkUserOpen()
      })
    },
    //关闭核验经办人弹窗
    colseQR() {
      this.QRshow = false
      clearTimeout(this.timer)
    },

    // 打开核验经办人弹窗获取二维码
    async checkUserOpen() {
      this.QRshow = true
      this.loading = true
      let { data } = await this.$Ajax.get(
        '/api/services/app/JZZJFApi/GetCheckApplicationQR?guid=' + this.form.guid
      )
      this.QRcode = data.result.qrBase64String
      this.loading = false
      this.checkUser(data.result.contextId)
    },
    openQrCodeUpload(property, isArray, isReadInfo, readIdInfoAfterToView) {
      this.$emit('openQrCodeUpload', property, isArray, isReadInfo, readIdInfoAfterToView)
    },
    // 核验经办人 获取个人信息轮询
    // TODO 这个页面可以重复提交，材料页面不能 */
    checkUser(contextId) {
      let _this = this
      const poll = async () => {
        let { data } = await this.$Ajax.get(`/api/services/app/JZZJFApi/CheckApplicationResult`, {
          params: { contextId },
        })
        if (data.result.success) {
          // _this.bindUserColse()
          _this.colseQR()
          this.$Message.success({
            content: '核验成功，正在提交...',
            background: true,
            duration: 6,
          })
          await this.$emit(
            'submit',
            '/api/services/app/JZZJFApi/SaveAppPersonalInfoChangeInfo',
            1,
            '提交成功'
          )
        } else {
          _this.timer = setTimeout(poll, 2500)
        }
      }
      poll()
    },
    //移除文件
    async handleRemove(file, fileList, property, isArray) {
      this.$emit('handleRemove', file, fileList, property, isArray)
    },
    //文件上传成功
    handleSuccess(response, file, fileList, property, isArray) {
      this.$emit('handleSuccess', response, file, fileList, property, isArray)
    },
    //文件格式错误
    handleFormatError(file) {
      this.$emit('handleFormatError', file)
    },
    //文件预览
    handlePreview(file) {
      this.$emit('handlePreview', file)
    },
  },
}
</script>